// extracted by mini-css-extract-plugin
module.exports = {"paymentInformation":"styles_paymentInformation__m1mZ0"};